// api
import { fetchApi } from '@/api'
// actions
const academicStudentAll = (context) => {
  let url = 'academic/students'
  return fetchApi(url, [], 'GET')
    .then((response) => {
      context.commit('ACADEMIC_STUDENTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicStudentProduct = (context, data) => {
  let json = JSON.stringify(data)
  let url = 'restaurant/getproductstudents'
  return fetchApi(url, json, 'POST')
    .then((response) => {
      console.log("resoyesta error",response)
      context.commit('ACADEMIC_STUDENTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.log("resoyesta error",error)
      console.error(error)
    })
}

const academicStudentCreate = (context, data) => {
  let json = JSON.stringify(data)
  let url = 'academic/students'
  return fetchApi(url, json, 'POST')
    .then((response) => {
      console.log("resoyesta error",response)
      context.commit('ACADEMIC_STUDENTS_ALL', response)
    })
    .catch((error) => {
      console.log("resoyesta",error)
      context.commit('ACADEMIC_STUDENTS_ALL', error)

      console.error(error)
    })
}

const academicStudentEdit = (context, data) => {
  let url = 'academic/students/' + data.id + '/edit'
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ACADEMIC_STUDENTS_ALL', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const academicStudentUpdate = (context, data) => {
  let json = JSON.stringify(data)
  let url = 'academic/students/' + data.id
  return fetchApi(url, json, 'PUT')
    .then((response) => {
      context.commit('ACADEMIC_STUDENTS_ALL', response)
    })
    .catch((error) => {
      console.error(error)
    })
}



export default {
  academicStudentAll,
  academicStudentProduct,
  academicStudentCreate,
  academicStudentEdit,
  academicStudentUpdate
}



// WEBPACK FOOTER //
// ./src/store/modules/academic/student/actions.js